<template>
	<div class="row">
		<div class="col-sm-5 col-md-5">
			<h3>Account Info</h3>
			<hr>
			<div class="row">
				<app-account-card v-if="account.accountId" :account="account"></app-account-card>
			</div>
<!--			<div class="row" v-if="tokenRelationships.length <= 0">-->
<!--				<button type="submit" class="btn btn-primary" @click.prevent="createToken">Create Token-->
<!--				</button>-->
<!--			</div>-->
			<hr>
			<div class="row">
				<button type="submit" class="btn btn-primary" @click.prevent="$router.push({name : 'registerSinger'})">Register Singer
				</button>
			</div>
		</div>
		<div class="col-sm-5 col-sm-offset-1">
			<h3>Token Info</h3>
			<hr>
			<app-token-list :is-admin="true" :account="account" :tokens="tokens"></app-token-list>
		</div>
	</div>
</template>

<script>
	import TokenList from "@/components/token/TokenList";
	import AccountCard from "@/components/account/AccountCard";
	import { EventBus } from "@/eventBus";
	import { PrivateKey } from "@hashgraph/sdk";
	import { tokenCreate } from "@/service/tokenService";
	import { saveTokenToFirebase } from "@/service/firebaseService";
	import { accountGetInfo } from "@/service/accountInfo";

	export default {
		data() {
			return {
				name: 'IndieToken',
				symbol: 'IDT',
				decimals: '1',
				initialSupply: '1000000000',
				tokenRelationships: {}
			}
		},
		computed: {
			account() {
				return this.$store.getters.getAdmin;
			},
			tokens() {
				return this.tokenRelationships;
			}
		},
		components: {
			appAccountCard: AccountCard,
			appTokenList: TokenList
		},
		methods: {
			async createToken() {
				try {
					EventBus.$emit('busy', true);
					const privateKey = await PrivateKey.generate()

					const issuerAccount = this.$store.getters.getAdmin;
					console.log('issuerAccount : ' + issuerAccount.wallet);

					const token = {
						name: this.name,
						symbol: this.symbol,
						decimals: this.decimals,
						initialSupply: this.initialSupply,
						adminKey: privateKey.toString(),
						kycKey: privateKey.toString(),
						freezeKey: privateKey.toString(),
						wipeKey: privateKey.toString(),
						supplyKey: privateKey.toString(),
						defaultFreezeStatus: true,
						autoRenewAccount: issuerAccount.accountId,
						treasury: issuerAccount.accountId,
						deleted: false,
						key: privateKey.toString()
					};

					const newToken = await tokenCreate(issuerAccount, token);
					if (newToken.tokenId === undefined) {
						console.log('failed to create token');
						return;
					}
					console.log('new token has been created');
					console.log(newToken);
					await saveTokenToFirebase(newToken);
					this.$store.commit('setToken', newToken);
					await this.getTokens();
				} catch (err) {
					console.log('-------------- Admin createToken exception --------------');
					console.log(err.message);
				}
			},
			async getTokens() {
				const resultTokens = [];
				const tokenRelationships = await accountGetInfo(this.account.accountId);
				for (const key in tokenRelationships) {
					const tokenRelationship = tokenRelationships[key];
					resultTokens.push(tokenRelationship);
				}
				this.tokenRelationships = resultTokens;
				return resultTokens;
			},
			registerSinger() {
				this.$router.push({name : 'registerSinger'});
			}
		},
		created() {
			console.log(this.$store.getters.isLoggedIn);
			if(!this.$store.getters.isLoggedIn) {
				this.$router.push({name: 'login'});
			}

			this.getTokens().then(resultTokens => {
						console.log('resultTokens size ' + resultTokens.length);
						if(resultTokens.length < 1) {
							this.createToken();
						}
					})

			EventBus.$on('updateTokenStatus', result => {
				console.log('event updateTokenStatus on : ' + result);
				if(result) {
					this.getTokens();
				}
			});
		}
	}
</script>

<style scoped>

</style>